<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t("coinsflip.user_detail_report") }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t("coinsflip.user_detail_report_list") }} - User : {{ username }} </v-card-title>
        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters>
            <span class="mr-2">
              <v-text-field
                v-model="dateFrom"
                :label="$t('coinsflip.date_from')"
                placeholder="DD/MM/YYYY HH:mm:ss"
                outlined
                dense
                hide-details
                style="width: 200px"
              />
            </span>
            <span class="mr-2">
              <v-text-field
                v-model="dateTo"
                :label="$t('coinsflip.date_to')"
                placeholder="DD/MM/YYYY HH:mm:ss"
                outlined
                dense
                hide-details
                style="width: 200px"
              />
            </span>
            <!-- <span class="mr-2">
              <select-input
                v-model="status"
                :items="statusOptions"
                :label="$t('coinsflip.status')"
                style="width: 150px"
              />
            </span> -->
            <v-btn color="primary" @click="searchReport" class="mr-2"> {{ $t('search') }} </v-btn>
            <v-btn color="warning" @click="linkToCoinsFlipPage" class=""> {{ $t('back') }} </v-btn>
          </v-row>
        </v-card-actions>
        <v-card-actions class="pt-4 d-flex flex-column">
          <v-data-table
            mobile-breakpoint="0"
            style="width: 100%"
            :headers="headers"
            :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')"
            :loading="loading"
            :items="reportData"
            :items-per-page="itemsPerPage"
            :page="currentPage"
            @page-count="pageCount = $event"
            hide-default-footer
          >
            <template v-slot:[`item.username`]="{ item }">
              {{ item.username || '-' }}
            </template>
            <template v-slot:[`item.bet_amount`]="{ item }">
              {{ formatCurrency(item.bet_amount) }}
            </template>
            <template v-slot:[`item.bet_side`]="{ item }">
              <v-chip small :color="getBetSideColor(item.bet_side)">
                {{ item.bet_side }}
              </v-chip>
            </template>
            <template v-slot:[`item.bet_result`]="{ item }">
              <v-chip small :color="getBetResultText(item.bet_result)">
                {{ item.bet_result }}
              </v-chip>
            </template>
            <template v-slot:[`item.win_loss`]="{ item }">
              <span :class="item.win_loss >= 0 ? 'success--text' : 'error--text'">
                {{ formatCurrency(item.win_loss) }}
              </span>
            </template>
            <template v-slot:[`item.web_profit`]="{ item }">
              {{ formatCurrency(item.web_profit) }}
            </template>
            <template v-slot:[`item.company_profit`]="{ item }">
              {{ formatCurrency(item.company_profit) }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip small :color="getStatusColor(item.status)">
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              {{ formatDateTime(item.created_at) }}
            </template>
          </v-data-table>

          <div class="text-center pt-2">
            <v-pagination
              v-model="currentPage"
              :length="pageCount"
              :total-visible="7"
              @input="loadReport"
            ></v-pagination>
          </div>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import SelectInput from '@/components/input/SelectInput.vue'
import store from '@/store'

export default {
  components: {
    SelectInput,
  },

  data() {
    return {
      userId: null,
      username: null,
      dateFrom: moment().subtract(7, 'days').format('DD/MM/YYYY HH:mm:ss'),
      dateTo: moment().format('DD/MM/YYYY HH:mm:ss'),
      status: 'all',
      statusOptions: [
        { text: this.$t('coinsflip.status_all'), value: 'all' },
        { text: this.$t('coinsflip.status_success'), value: 'success' },
        { text: this.$t('coinsflip.status_failed'), value: 'failed' },
        { text: this.$t('coinsflip.status_wait'), value: 'wait' },
      ],
      headers: [
        {
          text: this.$t('coinsflip.round_id'),
          value: 'round_id',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.username'),
          value: 'username',
          width: '150px',
          align: 'left',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.bet_amount'),
          value: 'bet_amount',
          width: '120px',
          align: 'right',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.bet_side'),
          value: 'bet_side',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.bet_result'),
          value: 'bet_result',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.win_loss'),
          value: 'win_loss',
          width: '120px',
          align: 'right',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.web_profit'),
          value: 'web_profit',
          width: '120px',
          align: 'right',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.company_profit'),
          value: 'company_profit',
          width: '120px',
          align: 'right',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.status'),
          value: 'status',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.created_at'),
          value: 'created_at',
          width: '150px',
          align: 'center',
          sortable: false,
        },
      ],
      reportData: [],
      loading: false,
      currentPage: 1,
      itemsPerPage: 25,
      pageCount: 0,
    }
  },
  async created() {
    this.userId = this.$route.query.user_id
    this.username = this.$route.query.username

    if (this.$route.query.date_from) this.dateFrom = this.$route.query.date_from
    if (this.$route.query.date_to) this.dateTo = this.$route.query.date_to
    if (this.$route.query.status) this.status = this.$route.query.status

    this.addLogPage()
    await this.loadReport()
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'รายละเอียดผู้เล่นหัวก้อย',
            url: window.location.href,
            detail: 'รายละเอียดผู้เล่นหัวก้อย',
            admin: userSystem.name ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // Error handling
      }
    },
    async searchReport() {
      this.currentPage = 1
      await this.loadReport()
    },
    async loadReport() {
      if (!this.userId) {
        this.$swal.fire({
          icon: 'error',
          title: this.$t('coinsflip.user_id_required'),
        })
        return
      }

      this.loading = true
      this.reportData = []

      try {
        const params = { user_id: this.userId }
        if (this.dateFrom) params.date_from = this.dateFrom
        if (this.dateTo) params.date_to = this.dateTo
        if (this.status && this.status !== 'all') params.status = this.status

        const rs = await this.$store.dispatch('getUserDetailReport', params)

        if (rs && rs.data) {
          this.reportData = rs.data.map(item => ({
            id: item.id,
            round_id: item.round_id,
            user_id: item.user_id,
            username: item.username,
            bet_amount: item.bet_amount || 0,
            bet_side: item.bet_side,
            bet_result: item.bet_result,
            win_loss: item.win_loss || 0,
            web_profit: item.web_profit || 0,
            company_profit: item.company_profit || 0,
            status: item.status,
            created_at: item.created_at,
          }))
          this.pageCount = Math.ceil(rs.count / this.itemsPerPage)
        }
      } catch (err) {
        this.$swal.fire({
          icon: 'error',
          title: err.message || this.$t('error_occurred'),
        })
      } finally {
        this.loading = false
      }
    },
    formatCurrency(value) {
      return parseFloat(value || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    formatDateTime(date) {
      if (!date) return '-'
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    getBetSideColor(side) {
      const colors = {
        head: 'primary',
        center: 'warning',
        tail: 'success',
      }
      return colors[side] || 'black'
    },
    getBetResultColor(result) {
      const colors = {
        head: 'primary',
        center: 'warning',
        tail: 'success',
      }
      return colors[result] || 'black'
    },
    getStatusColor(status) {
      const colors = {
        success: 'success',
        failed: 'error',
        wait: 'warning',
      }
      return colors[status] || 'black'
    },
    getBetResultText(result) {
      const texts = {
        win: 'success',
        lose: 'error',
        error: 'error',
      }
      return texts[result] || 'black'
    },
    linkToCoinsFlipPage() {
      this.$router.push({ name: 'coinsflip' })
    },
  },
}
</script>

